import React from 'react';
import { useLanguage } from '../../context/LanguageContext';

const MissionVision = () => {
  const { t } = useLanguage();
  
  return (
    <section className="bg-white py-16 lg:py-24">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-16">
          {/* Mission */}
          <div className="space-y-4">
            <h3 className="font-montserrat font-black text-[#e21b1b] text-xl sm:text-2xl">
              {t('missionVision.missionTitle')}
            </h3>
            <p className="font-roboto text-gray-700 text-base sm:text-lg leading-relaxed text-justify">
              {t('missionVision.missionText')}
            </p>
          </div>

          {/* Vision */}
          <div className="space-y-4">
            <h3 className="font-montserrat font-black text-[#e21b1b] text-xl sm:text-2xl">
              {t('missionVision.visionTitle')}
            </h3>
            <p className="font-roboto text-gray-700 text-base sm:text-lg leading-relaxed text-justify">
              {t('missionVision.visionText')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MissionVision;
